import styles from './Product.module.scss'

const DeliveryAndPayment = () => (
  <div className={styles.payment}>
    <div className={styles.payment_container}>
      <p className={styles.payment_title}>Способи доставки</p>

      <div className={styles.payment_title_container}>
        <p className={styles.payment_subtitle}>Нова Пошта</p>
        <p className={styles.payment_description}>
          Доставка у відділення \"Нової пошти\" (згідно з тарифами перевізника)
        </p>
      </div>

      <div className={styles.payment_title_container}>
        <p className={styles.payment_subtitle}>Адресна доставка кур'єром</p>
        <p className={styles.payment_description}>
          Адресна доставка кур'єром \"Нової пошти\" (згідно з тарифами перевізника)
        </p>
      </div>
    </div>

    <div className={styles.payment_container}>
      <p className={styles.payment_title}>Способи оплати</p>

      <div className={styles.payment_title_container}>
        <p className={styles.payment_subtitle}>Післяплата \"Нова Пошта\"</p>
        <p className={styles.payment_description}>Комісія за переказ - 20 грн. + 2% від суми переказу</p>
      </div>

      <div className={styles.payment_title_container}>
        <p className={styles.payment_subtitle}>Онлайн-оплата</p>
        <p className={styles.payment_description}>Безпечна Онлайн оплата карткою Visa / Mastercard</p>
      </div>
    </div>

    <p className={styles.payment_description}>Гарантія повернення товару протягом 14 днів з моменту покупки</p>
  </div>
)

export default DeliveryAndPayment
